import { render } from "./ModalSegurança.vue?vue&type=template&id=4b763109&scoped=true"
import script from "./ModalSegurança.vue?vue&type=script&lang=js"
export * from "./ModalSegurança.vue?vue&type=script&lang=js"

import "./ModalSegurança.vue?vue&type=style&index=0&id=4b763109&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b763109"]])

export default __exports__